
const Footer = () => {
  return <footer className="container">Copyright 2021 EMGE Resources</footer>;
};

export default Footer;
